import { render, staticRenderFns } from "./PackingListDetail.vue?vue&type=template&id=27494125&"
import script from "./PackingListDetail.vue?vue&type=script&lang=js&"
export * from "./PackingListDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackingListDetail.vue?vue&type=style&index=0&id=27494125&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports